'use strict';

// external imports
import React, {
    useMemo
} from 'react';
import {useSelector} from 'react-redux';
import {keys} from 'ts-transformer-keys';

// prime react imports
import {Toolbar as PrimeToolbar} from 'primereact/toolbar';

// shared imports
import {__} from '~/shared/src/utilities/messageCatalog';

// frontend imports
import {
    getToolbarComponents,
    ToolbarComponents,
    ToolbarLayoutComponents
} from '~/frontend/src/utilities/toolbars';

import {StoreState} from '~/frontend/src/store';


export type DefaultProps = {};
export const defaultProps : Required<DefaultProps> = {};

type Props = {
    uid : string;

    dataContext : string;
    rootItemId? : number;

    style? : CssStyle;
};

export type ComponentProps = DefaultProps & Props;
export const componentProps = keys<ComponentProps>();

type AllProps = DefaultProps & Props;


/**
 * Headerbar
 */
const Headerbar = ( props : AllProps ) => {
    const {
              dataContext,
              rootItemId,
              style,
              uid
          }        = props,
          user     = useSelector( ( state : StoreState ) => state.session?.user ),
          language = user
              ? user.language
              : undefined,
          rootItem = useMemo(
              () => {
                  if ( rootItemId ) {
                      return global.data[ dataContext ]?.items[ rootItemId ];
                  }
                  else {
                      return undefined;
                  }
              },
              [
                  dataContext,
                  rootItemId
              ]
          );

    return useMemo(
        () => {
            const layoutComponents : ToolbarLayoutComponents = {
                left : [],
                right: []
            };

            // left
            layoutComponents.left.push( {
                type  : 'genericNode',
                params: <label
                    key="title"
                    className="yn-label yn-label-value"
                >
                    {__( 'YN.base.frontend.mapSearch.header.title' )}
                </label>
            } );

            if ( layoutComponents.left.length ) {
                layoutComponents.left.push( {
                    type  : 'genericNode',
                    params: <i key={`separator_${layoutComponents.left.length}`} className="p-toolbar-separator ml-4 mr-4"/>
                } );
            }

            layoutComponents.left.push( {
                type  : 'genericNode',
                params: <label
                    key="itemLabel"
                    className="yn-label yn-label-key mr-2"
                >
                    {rootItem?.displayAttributeValue}
                </label>
            } );

            const toolbarComponents : ToolbarComponents = getToolbarComponents( layoutComponents );

            return <PrimeToolbar
                key={uid}
                start={toolbarComponents.left}
                end={toolbarComponents.right}
                className="yn-panel-headerbar yn-toolbar-horizontal-separator-bottom"
                style={{
                    zIndex: 6,
                    ...style
                }}
            />;
        },
        [
            language,
            rootItem,
            uid
        ]
    );
};

Headerbar.defaultProps = defaultProps;
Headerbar.displayName = 'FormDesigner-Headerbar';

export default Headerbar;
